export default __webpack_public_path__ + "static/img/31.09f6f51.png";